import { createPasskey, createPasskeyAttestation, getPasskeyRegistrationOptions } from '@pba/client-auth';
import { useQueryClient } from '@tanstack/react-query';
import { useRelyingPartyId } from 'lib/webauthn/hooks';
import { useMutation } from 'query';
import { getPasskeysListQueryKey } from '../keys';

type CreatePasskeyVariables = {
  name: string;
};

export const useCreatePasskey = () => {
  const queryClient = useQueryClient();
  const getRelyingPartyId = useRelyingPartyId();

  return useMutation<unknown, CreatePasskeyVariables>({
    async mutationFn({ name }) {
      // eslint-disable-next-line @typescript-eslint/naming-convention -- Defined by external API
      const relyingPartyID = getRelyingPartyId();

      const { data: registrationOptionsResult } = await getPasskeyRegistrationOptions({
        // eslint-disable-next-line @typescript-eslint/naming-convention -- Defined by external API
        body: { relyingPartyID },
      });

      const { options, token } = registrationOptionsResult;
      const attestationResponse = await createPasskeyAttestation({
        options,
      });

      await createPasskey({
        body: {
          name,
          response: attestationResponse,
          token,
        },
      });
    },

    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getPasskeysListQueryKey({}) });
    },
  });
};
